import i18n from 'modules/core/lib/i18n'

export const WIDTH_PROJECTS_COLUMN = 5
export const WIDTH_WEEKDAYS_COLUMN = 2
export const WIDTH_TABLE = 20
export const TOTAL_DAY_MINUTES = 1440

export const DEFAULT_CURRENCY = 'EUR'
export const DEFAULT_PROFIT_MARGIN = '30'

export type graphViewsDetailViewOptionEnum = 'employees' | 'subprojects'

export type graphViewsCostOptionEvolutionEnum = 'evolution' | 'breakdown'

export const getPeopleCount = (peopleCount: number) => {
  return peopleCount + ' ' + i18n.tp('common.person', { count: peopleCount })
}

export const projectAttributes = {
  projectName: 'name',
  projectCode: 'code',
  projectDescription: 'description',
  startDate: 'startDate',
  dueDate: 'dueDate',
  client: 'client',
} as const

export type financialDetailsAttributes =
  | 'legalEntityId'
  | 'fixedCost'
  | 'isBillable'
  | 'currencyType'

export enum overviewFilterOptionsEnum {
  currentWeek = 'current_week',
  lastWeek = 'last_week',
  currentMonth = 'current_month',
  lastMonth = 'last_month',
  customRange = 'custom_range',
  wholeProject = 'whole_project',
}

export enum overviewFrequencyOptionsEnum {
  daily = 'days',
  weekly = 'weeks',
  monthly = 'months',
  yearly = 'years',
}

export enum budgetTypesEnum {
  fixedTimeBudget = 'fixed_time_budget',
  projectFixedCost = 'project_fixed_cost',
  totalBudget = 'total_budget',
  withoutBudget = 'without_budget',
}

export type maxMinutesPerCurrentWeekTypes = 'estimated' | 'worked'

export enum offDayTypesEnum {
  holidaysCompanyHoliday = 'HolidaysCompanyHoliday',
  timeoffLeave = 'TimeoffLeave',
  timePlanningEstimatedWorkDay = 'TimePlanningEstimatedWorkDay',
  withoutOffDay = 'WithoutOffDay',
}
